export const FORM_NAME = 'department';
